import { Component, OnInit } from '@angular/core';
import { EmagazineService, EmagIssue } from './emagazine.service';
import { ThemeCustomizerService } from '../components/common/theme-customizer/theme-customizer.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-emagazine-list',
  templateUrl: './emagazine-list.component.html',
  styleUrls: ['./emagazine-list.component.scss']
})
export class EmagazineListComponent implements OnInit {
  loading = true;
  issues: EmagIssue[] = [];

  years: string[] = [];
  grouped: Record<string, EmagIssue[]> = {};
  activeYear = '';

  selected?: EmagIssue;
  selectedPdfUrl = '';
  safePdfUrl: SafeResourceUrl | null = null; // for iframe

  constructor(
    public themeService: ThemeCustomizerService,
    private api: EmagazineService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.api.listPublic().subscribe({
      next: rows => {
        this.issues = rows || [];
        this.groupByYear();
        this.loading = false;

        const first = this.grouped[this.activeYear]?.[0];
        if (first) this.select(first);
      },
      error: () => {
        this.loading = false;
        this.issues = [];
        this.grouped = {};
        this.years = [];
        this.activeYear = '';
        this.selected = undefined;
        this.setPdf('');
      }
    });
  }

  private groupByYear() {
    const byYear: Record<string, EmagIssue[]> = {};
    for (const it of this.issues) {
      const d = it.publish_date ? new Date(it.publish_date) : undefined;
      const y = d && !isNaN(d.getTime()) ? String(d.getFullYear()) : 'Unknown';
      (byYear[y] ||= []).push(it);
    }
    Object.keys(byYear).forEach(y => {
      byYear[y].sort((a, b) => {
        const da = a.publish_date ? new Date(a.publish_date).getTime() : 0;
        const db = b.publish_date ? new Date(b.publish_date).getTime() : 0;
        return db - da;
      });
    });
    this.grouped = byYear;
    this.years = Object.keys(byYear).sort((a, b) =>
      b.localeCompare(a, undefined, { numeric: true })
    );
    this.activeYear = this.years[0] || '';
  }

  setYear(y: string) {
    this.activeYear = y;
    const first = this.grouped[y]?.[0];
    if (first) this.select(first);
  }

  select(issue: EmagIssue) {
    this.selected = issue;
    this.setPdf(issue?.pdf_path || '');
  }

  private setPdf(url: string) {
    this.selectedPdfUrl = url;
    this.safePdfUrl = url
      ? this.sanitizer.bypassSecurityTrustResourceUrl(url)
      : null;
  }

  trackById(_: number, it: EmagIssue) { return it?.id; }

  formatDate(input?: string | Date | null): string {
    if (!input) return '';
    const d = new Date(input);
    if (isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', {
      month: 'short', day: 'numeric', year: 'numeric'
    }).format(d);
  }
}
